import React from 'react';
import './Preloader.scss';

interface IPreloaderProps {
  height: string;
}

export const Preloader = ({ height }: IPreloaderProps) => {
  return (
    <div
      style={{
        height: height,
      }}
    >
      <div className="preloader-wrapper big active loader">
        <div className="spinner-layer spinner-green-only">
          <div className="circle-clipper left">
            <div className="circle"></div>
          </div>
          <div className="gap-patch">
            <div className="circle"></div>
          </div>
          <div className="circle-clipper right">
            <div className="circle"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
